module.exports = __webpack_public_path__ + "media/images/mock-thumbs/event-2-4b32053e1110e976af1937d2f2c8a44f.png";